import DomainEntity from '@/models/DomainEntity'

export default class StrategyLoans extends DomainEntity {
  static get collectionName() {
    return 'strategyloans/'
  }

  static get parentKey() {
    return 'strategy'
  }

  static defaults() {
    return {
      add: [],
      update: {},
      delete: [],
    }
  }
}
